import React, { useEffect } from "react";
import { FLAT_RATE_PLANS, flatRatePlanNames } from "@common/flatRateBilling";
import { SubscriptionType } from "@common/types/billing";
import { useTimer } from "@hooks/useTimer";
import { useBillingStatus } from "@hooks/useBillingStatus";
import { useCanManageWorkspaceBilling } from "@hooks/permissions/useCanManageWorkspaceBilling";
import { PageCoverLoader } from "@design-system/PageCoverLoader/PageCoverLoader";
import styles from "./Outro.module.scss";

interface Props {
    onFinished(): void;
}
export const Outro: React.FC<Props> = ({ onFinished }) => {
    const { start } = useTimer(onFinished, 3_000);
    const { isFetched, currentPlan, subscriptionType, bookedEnterpriseCall } =
        useBillingStatus();
    const canManageBilling = useCanManageWorkspaceBilling();

    useEffect(() => {
        if (isFetched) {
            start();
        }
    }, [isFetched, start]);

    const currentPlanName = flatRatePlanNames[currentPlan];
    let headline: React.ReactNode;
    let title: React.ReactNode = "Processing your data";

    if (
        subscriptionType !== SubscriptionType.FLAT_RATE ||
        currentPlan === FLAT_RATE_PLANS.FREE ||
        !canManageBilling
    ) {
        headline = "Get ready to kick back...";
    } else if (bookedEnterpriseCall) {
        title = "You're all set for your call";
        headline = <>Start exploring</>;
    } else {
        headline = (
            <>
                Your {currentPlanName} plan trial is about to start, get ready
                to kick back...
            </>
        );
    }

    return (
        <PageCoverLoader backdrop className={styles.cover} logo={false}>
            <div className={styles.outro}>
                <h1 className="onboarding__title">{title}</h1>
                {headline && <p className="onboarding__headline">{headline}</p>}
            </div>
        </PageCoverLoader>
    );
};
